export enum VoteValue {
  ACCEPT = 'ACCEPT',
  DECLINE = 'DECLINE',
  ABSTAIN = 'ABSTAIN',
}
